import { AsyncDataProvider } from 'modules/data-providers';
import { useSelector } from 'modules/react-redux';
import { PropsWithChildren, useCallback } from 'react';
import { useGetNetSuiteVendorCategories } from 'shared/data/webApp/v1';

import { getRequest } from '../../../../selectors/pageSelectors';
import { getRequestEditMode } from '../../../../selectors/requestSelectors';

export const NetSuiteVendorCategoriesDataProvider = (props: PropsWithChildren) => {
    const { children } = props;

    const request = useSelector(getRequest);
    const editMode = useSelector((state) => getRequestEditMode(state, request));

    const { id: requestId, companyId } = request;

    const { refetch } = useGetNetSuiteVendorCategories(
        {
            query: { companyId },
        },
        {
            enabled: false,
        }
    );

    const onLoad = useCallback(async () => {
        const { data } = await refetch();

        return data?.values.map(({ id, name }) => ({ id, text: name })) || [];
    }, [refetch]);

    return (
        <AsyncDataProvider
            cacheStorageId={`requestOptions.netSuiteVendorCategories.${requestId}.${editMode}`}
            pageSize={100}
            onLoad={onLoad}
        >
            {children}
        </AsyncDataProvider>
    );
};

NetSuiteVendorCategoriesDataProvider.displayName = 'NetSuiteVendorCategoriesDataProvider';
